import KeenSlider, { KeenSliderInstance } from 'keen-slider';

import {
  initCarousel,
  CarouselOptions,
  InitCarouselParams,
} from '../../objects/carousel';
import {
  responsiveMediaAbove,
  responsiveMediaBelow,
  responsiveQuery,
} from '../../settings/responsive';
import { CLASS_INITIALISED } from '../../tools/constants/classes';

const SELECTOR_CONTAINER = '[data-product-features]';
const SELECTOR_CAROUSEL = '[data-product-features-carousel]';
const ATTR_NO_DESKTOP_CAROUSEL = 'data-no-desktop-carousel';
const SELECTOR_NAV_NEXT = '[data-carousel-next]';
const SELECTOR_NAV_PREV = '[data-carousel-previous]';
const isBundleLanding = !document.body.classList.contains('c-page--bundle-landing');

function initProductFeatures() {
  document.querySelectorAll(SELECTOR_CONTAINER).forEach((container) => {
    const carouselElement =
      container.querySelector<HTMLElement>(SELECTOR_CAROUSEL);
    const noCarouselDesktop = container.hasAttribute(ATTR_NO_DESKTOP_CAROUSEL);
    const nextArrow = container.querySelector(SELECTOR_NAV_NEXT);
    const prevArrow = container.querySelector(SELECTOR_NAV_PREV);
    let options;
    options = {
      slides: {
        perView: 1.25,
        spacing: 24,
      },
      loop: true,
      breakpoints: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '(min-width: 550px)': {
          slides: {
            perView: 1.8,
            spacing: 24,
          },
        },
        [responsiveQuery('SMALL')]: {
          slides: {
            perView: 2.4,
            spacing: 24,
            origin: isBundleLanding ? 'center' : 0,
          },
          loop: true,
        },
        [responsiveQuery('MEDIUM')]: {
          slides: {
            perView: 3,
            spacing: 32,
            origin: isBundleLanding ? 'center' : 0,
          },
          loop: true,
        },
      },
    };

    if (noCarouselDesktop) {
      options = {
        slides: {
          perView: 1.25,
          spacing: 24,
        },
        loop: true,
        breakpoints: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '(min-width: 550px)': {
            slides: {
              perView: 1.8,
              spacing: 32,
            },
            loop: true,
          },
          [responsiveQuery('SMALL')]: {
            slides: {
              perView: 2.4,
              spacing: 32,
              origin: 'center',
            },
            loop: true,
          },
          [responsiveQuery('MEDIUM')]: {
            created: (slider: KeenSliderInstance) => slider.destroy(),
          },
        },
      };
    }
    if (!carouselElement) return;

    nextArrow?.addEventListener('click', () => {
      if (!carousel) return;
      carousel.slider.next();
    });
    prevArrow?.addEventListener('click', () => {
      if (!carousel) return;
      carousel.slider.prev();
    });

    const params: InitCarouselParams = { container: carouselElement, options };
    const carousel = initCarousel(params);

    // Remove carousel functionality on medium breakpoint and above on resize and load
    const onResize = () => {
      if (!carousel) return;
      const slider = carousel.slider;
      if (responsiveMediaAbove('MEDIUM')) {
        slider.destroy();
      } else if (responsiveMediaBelow('MEDIUM')) {
        slider.update();
      }
    };

    if (noCarouselDesktop) {
      window.addEventListener('resize', onResize);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initProductFeatures());
document.addEventListener('shopify:section:load', () => initProductFeatures());
